export enum ListVariant {
    INLINE = "inline"
}
